

<template>
  <!-- Order Promo Start -->

  <section class="order_promo_area">
    <div class="container">
      <img class="promo_shape" src="../assets/img/promo_leaf_bg.png" alt="img" />
      <div class="row">
        <div class="col-lg-6" v-for="(item, key) in featuredProducts" :key="key">
          <div class="order_promo_box">
            <img v-bind:src="require(`@/assets/img/${item.img}`)" alt="img" />
            <div class="promo_order_text">
              <h2>{{ item.title }}</h2>
              <a
                href="https://wa.me/5216647980740"
                class="cta_btn small_btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="fab fa-whatsapp"></i> Pide ya
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Order Promo End -->
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "OrderPromoArea",
  computed: {
    ...mapState({
      featuredProducts: function (state) {
        return state.products.featuredItems;
      },
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/OrderPromoArea.vue